<script>
	import PlashNav from './PlashNav.svelte';
	import { lang } from '$lib/translations/menu';
	/**
	 * @type {{ slug: any; name: string; }}
	 */
	export let item, onOpenOpenPlash;

	let hoverActive = false;
</script>

<div
	class=""
	on:mouseenter={() => {
		hoverActive = true;
	}}
	on:mouseleave={() => {
		hoverActive = false;
	}}
>
	<a
		rel="external"
		class="text-[10px] w-full relative md:mr-[15px] lg:mr-[35px] xl:mr-[65px] font-bold text-custom-white-bg"
		href={item.slug}
	>
		{#if hoverActive}
			<div class="border-[#FFFFFF] border-t-[3px] absolute -top-5 h-[3px] left-0 w-full" />
		{/if}
		{item.name.toUpperCase()}
	</a>
</div>
